import { Actions } from '@ngrx/effects';
import { AppState } from '@_store/index.reducers';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { CompanyStudyConclusionApiService } from '@_services/api/company-study-conclusion-api.service';
import { GeneratedCompanyStudyConclusionEffects } from './company-study-conclusion-generated.effects';

@Injectable()
export class CompanyStudyConclusionEffects extends GeneratedCompanyStudyConclusionEffects {
  constructor(
    actions$: Actions,
    companyStudyConclusionApiService: CompanyStudyConclusionApiService,
    store$: Store<AppState>
  ) {
    super(actions$, companyStudyConclusionApiService, store$);
  }
}
